import { ReactNode } from 'react';

import { cn } from '@cccom/ui/src/utils';

import { SidebarTrigger, useSidebar } from '../../shadcn/sidebar';
import { AppLogo, AppLogoProps } from './AppLogo';

export type TopbarProps = {
  hasSidebar?: boolean;
  logoProps?: AppLogoProps;
  siteSelector?: ReactNode;
  appTierBadge?: ReactNode;
  className?: string;
};

export function Topbar({
  hasSidebar,
  logoProps,
  siteSelector,
  appTierBadge,
  className,
}: TopbarProps) {
  const { state } = useSidebar();

  return (
    <div
      className={cn(
        'border-t-primary border-b border-t-4 border-b-gray-200 bg-white',
        className
      )}
    >
      <nav className="bg-surface flex h-[calc(var(--topbar-height)-5px)] items-center justify-between px-7">
        <div className="flex items-center space-x-4">
          {hasSidebar && <SidebarTrigger />}

          {logoProps && state === 'collapsed' && <AppLogo {...logoProps} />}
        </div>

        <div className="flex items-center gap-4">
          {appTierBadge}
          {siteSelector}
        </div>
      </nav>
    </div>
  );
}
